import { combineReducers } from 'redux';
import getTop from './getTop';
import getGoods from './getGoods';
import getCd from './getCd';
import getStory from './getStory';
import getHeader from './getHeader';

const syunkokuApp = combineReducers({
	getTop,
	getGoods,
	getCd,
	getStory,
	getHeader,
})

export default syunkokuApp



// WEBPACK FOOTER //
// src/reducers/index.js